import { render, staticRenderFns } from "./SettingsStrategy.vue?vue&type=template&id=24018912&scoped=true&"
import script from "./SettingsStrategy.vue?vue&type=script&lang=js&"
export * from "./SettingsStrategy.vue?vue&type=script&lang=js&"
import style0 from "./SettingsStrategy.vue?vue&type=style&index=0&id=24018912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24018912",
  null
  
)

export default component.exports